import { useAtomsDevtools } from 'jotai-devtools';
import { useHydrateAtoms } from 'jotai/utils';

const { REACT_APP_ENABLE_ATOM_DEV_TOOLS } = process.env;

const Atoms = ({ children }) => {
  if (+REACT_APP_ENABLE_ATOM_DEV_TOOLS) {
    useAtomsDevtools('video');
  }

  return children;
};

// Allow the initial value for an atom to be set. https://jotai.org/docs/utilities/ssr
export const HydrateAtoms = ({ children, initialValues }) => {
  useHydrateAtoms(initialValues);
  return children;
};

export default Atoms;
